import { Sheet } from '@bluebeam/carnivore';

class CarnivoreSheet {
  sheet: Sheet;

  // It might be nice to build the actual creation of the
  // carn sheet in here.
  constructor(sheet: Sheet) {
    this.sheet = sheet;
  }
}

export default CarnivoreSheet;
